module.exports = __webpack_public_path__ + "img/phone-smile.42e6d844.svg";